export const isEmpty = (object?: object | null) => {
  if (!object) return true;
  return Object.keys(object).length === 0 && object.constructor === Object;
};

export interface KeyValuePair {
  key: string;
  value?: string;
}

export interface LabelValuePair {
  label?: string;
  value: string;
}
